// Mock data for Penilaian 360 module matching Figma designs

export const predicateCategories = [
  { id: 'sangat-kurang', label: 'Sangat Kurang', color: '#dc2626', bg: '#fef2f2', border: '#f87171' },
  { id: 'kurang', label: 'Kurang', color: '#d97706', bg: '#fffbeb', border: '#f59e0b' },
  { id: 'butuh-perbaikan', label: 'Butuh Perbaikan', color: '#ca8a04', bg: '#fefce8', border: '#eab308' },
  { id: 'baik', label: 'Baik', color: '#0284c7', bg: '#f0f9ff', border: '#38bdf8' },
  { id: 'sangat-baik', label: 'Sangat Baik', color: '#16a34a', bg: '#f0fdf4', border: '#4ade80' },
];

export const employeeList360 = [
  {
    uuid: 'emp-001',
    no: 1,
    nip: '198512202006042001',
    nama: 'SITI AISYAH',
    jabatan: 'Analis Kebijakan Madya',
    kategoriJabatan: 'Pelaksana',
    unitKerja: 'Deputi Bidang Perencanaan Penanaman Modal',
    penilai: '1/13',
    nilaiTotal: '224 Poin',
    nilaiAkhir360: '22.4',
    nilaiBerAkhlak: '22.27',
    predikat: 'Sangat Kurang',
    predikatId: 'sangat-kurang',
    level: 'Level 4',
  },
  {
    uuid: 'emp-002',
    no: 2,
    nip: '199003152010052003',
    nama: 'BUDI SANTOSO',
    jabatan: 'Manajer Proyek',
    kategoriJabatan: 'Pelaksana',
    unitKerja: 'Divisi Pengembangan Produk',
    penilai: '1/13',
    nilaiTotal: '310 Poin',
    nilaiAkhir360: '31.0',
    nilaiBerAkhlak: '30.85',
    predikat: 'Kurang',
    predikatId: 'kurang',
    level: 'Level 4',
  },
  {
    uuid: 'emp-003',
    no: 3,
    nip: '198512202006042001',
    nama: 'SITI AISYAH',
    jabatan: 'Analis Kebijakan Madya',
    kategoriJabatan: 'Pelaksana',
    unitKerja: 'Deputi Bidang Perencanaan Penanaman Modal',
    penilai: '0/13',
    nilaiTotal: '-',
    nilaiAkhir360: '-',
    nilaiBerAkhlak: '-',
    predikat: '-',
    predikatId: null,
    level: 'Level 3',
  },
  {
    uuid: 'emp-004',
    no: 4,
    nip: '199003150812301002',
    nama: 'RIZAL FAHMI',
    jabatan: 'Pengembang Sistem Informasi',
    kategoriJabatan: 'Pelaksana',
    unitKerja: 'Deputi Bidang Teknologi Informasi',
    penilai: '0/13',
    nilaiTotal: '-',
    nilaiAkhir360: '-',
    nilaiBerAkhlak: '-',
    predikat: '-',
    predikatId: null,
    level: 'Level 3',
  },
  {
    uuid: 'emp-005',
    no: 5,
    nip: '198711112009112003',
    nama: 'DWI LESTARI',
    jabatan: 'Manajer Proyek',
    kategoriJabatan: 'Pelaksana',
    unitKerja: 'Deputi Bidang Pengelolaan Proyek',
    penilai: '0/13',
    nilaiTotal: '-',
    nilaiAkhir360: '-',
    nilaiBerAkhlak: '-',
    predikat: '-',
    predikatId: null,
    level: 'Level 4',
  },
  {
    uuid: 'emp-006',
    no: 6,
    nip: '200001132023021003',
    nama: 'ALVIAN YUSUF MIZAN, A.Md.Ak.',
    jabatan: 'Pengolah Data dan Informasi',
    kategoriJabatan: 'Pelaksana',
    unitKerja: 'Biro Sumber Daya Manusia dan Organisasi',
    penilai: '1/13',
    nilaiTotal: '224 Poin',
    nilaiAkhir360: '22.4',
    nilaiBerAkhlak: '22.27',
    predikat: 'Sangat Kurang',
    predikatId: 'sangat-kurang',
    level: 'Level 4',
  },
  {
    uuid: 'emp-007',
    no: 7,
    nip: '199204122015031004',
    nama: 'AHMAD FAUZI',
    jabatan: 'Analis Kepegawaian Muda',
    kategoriJabatan: 'Pelaksana',
    unitKerja: 'Biro Sumber Daya Manusia dan Organisasi',
    penilai: '8/13',
    nilaiTotal: '450 Poin',
    nilaiAkhir360: '75.5',
    nilaiBerAkhlak: '74.80',
    predikat: 'Baik',
    predikatId: 'baik',
    level: 'Level 4',
  },
  {
    uuid: 'emp-008',
    no: 8,
    nip: '199408252019022005',
    nama: 'RATNA SARI',
    jabatan: 'Pranata Komputer Pertama',
    kategoriJabatan: 'Pelaksana',
    unitKerja: 'Pusat Data dan Informasi',
    penilai: '13/13',
    nilaiTotal: '520 Poin',
    nilaiAkhir360: '92.0',
    nilaiBerAkhlak: '91.50',
    predikat: 'Sangat Baik',
    predikatId: 'sangat-baik',
    level: 'Level 3',
  },
  {
    uuid: 'emp-009',
    no: 9,
    nip: '199105172016011002',
    nama: 'HENDRA KURNIAWAN',
    jabatan: 'Analis Kebijakan Pertama',
    kategoriJabatan: 'Pelaksana',
    unitKerja: 'Deputi Bidang Kerja Sama Penanaman Modal',
    penilai: '5/13',
    nilaiTotal: '380 Poin',
    nilaiAkhir360: '62.5',
    nilaiBerAkhlak: '61.80',
    predikat: 'Butuh Perbaikan',
    predikatId: 'butuh-perbaikan',
    level: 'Level 3',
  },
  {
    uuid: 'emp-010',
    no: 10,
    nip: '198909092014022001',
    nama: 'NURUL HIDAYAH',
    jabatan: 'Perancang Peraturan Perundang-undangan',
    kategoriJabatan: 'Pelaksana',
    unitKerja: 'Biro Hukum dan Regulasi',
    penilai: '2/13',
    nilaiTotal: '290 Poin',
    nilaiAkhir360: '35.0',
    nilaiBerAkhlak: '34.60',
    predikat: 'Kurang',
    predikatId: 'kurang',
    level: 'Level 4',
  }
];

export const sampleDetailBreakdown = {
  uuid: 'emp-006',
  employee: {
    nama: 'Alvian Yusuf Mizan, A.Md.Ak.',
    nip: '200001132023021003',
    jabatan: 'Pengolah Data dan Informasi',
    unitKerja: 'Biro Sumber Daya Manusia dan Organisasi',
    level: 'Level 4',
  },
  scores: {
    nilaiKeseluruhan: '22.4',
    predikatKeseluruhan: 'Sangat Kurang',
    predikatKeseluruhanId: 'sangat-kurang',
    berAkhlak360: '22.27',
    predikatBerAkhlak: 'Sangat Kurang',
    predikatBerAkhlakId: 'sangat-kurang',
  },
  totalMapping: 13,
  evaluatorGroups: [
    {
      groupId: 'atasan',
      groupTitle: '1. Kelompok Penilai: Atasan (Pejabat Level Lebih Tinggi)',
      bobotPercent: 75,
      weightClass: 'blue',
      themeClass: 'atasan',
      averageScore: '-',
      evaluators: [
        {
          no: 1,
          nama: 'Tentiana Rusbandi, S.H., M.H.',
          jabatan: 'Kepala Biro Sumber Daya Manusia dan Organisasi',
          skorTotal: '-',
          skorMaksimal: '-',
          skorAkhir: '-',
          status: null,
          hasAction: true,
        }
      ]
    },
    {
      groupId: 'rekan',
      groupTitle: '2. Kelompok Penilai: Rekan/Sejawat (Level Setara)',
      bobotPercent: 25,
      weightClass: 'green',
      themeClass: 'rekan',
      averageScore: '89.60',
      evaluators: [
        {
          no: 1,
          nama: 'Andri Atmadja, S.E.',
          jabatan: 'Analis Sumber Daya Manusia Aparatur Ahli Pertama',
          skorTotal: '-',
          skorMaksimal: '-',
          skorAkhir: '-',
          status: 'Draft',
        },
        {
          no: 2,
          nama: 'Damar Sianturrahman, S.Pd.',
          jabatan: 'Arsiparis Ahli Pertama',
          skorTotal: '224.00',
          skorMaksimal: '250',
          skorAkhir: '89.60',
          status: 'Submitted',
        },
        {
          no: 3,
          nama: 'Devinta Aldyati, S.Psi., M.B.A',
          jabatan: 'Analis Sumber Daya Manusia Aparatur Ahli Muda',
          skorTotal: '-',
          skorMaksimal: '-',
          skorAkhir: '-',
          status: 'Draft',
        },
        {
          no: 4,
          nama: 'Eko Prabowo, S.E.',
          jabatan: 'Analis Sumber Daya Manusia Aparatur Ahli Pertama',
          skorTotal: '-',
          skorMaksimal: '-',
          skorAkhir: '-',
          status: 'Draft',
        },
        {
          no: 5,
          nama: 'Hafidh Andrian Pratama, S.AB.',
          jabatan: 'Analis Sumber Daya Manusia Aparatur Ahli Pertama',
          skorTotal: '-',
          skorMaksimal: '-',
          skorAkhir: '-',
          status: 'Draft',
        },
        {
          no: 6,
          nama: 'Laili Audina Putri, S.E.',
          jabatan: 'Penata Layanan Operasional',
          skorTotal: '-',
          skorMaksimal: '-',
          skorAkhir: '-',
          status: 'Draft',
        },
        {
          no: 7,
          nama: 'Muhamad Baijuri, S.S.',
          jabatan: 'Analis Sumber Daya Manusia Aparatur Ahli Madya',
          skorTotal: '-',
          skorMaksimal: '-',
          skorAkhir: '-',
          status: 'Draft',
        }
      ]
    }
  ],
  roleWeightings: [
    {
      peran: 'Atasan',
      bobot: '75%',
      bobotVal: 0.75,
      nilaiRataRata: '-',
      nilaiAkhirSetelahBobot: '0.00'
    },
    {
      peran: 'Rekan / Sejawat',
      bobot: '25%',
      bobotVal: 0.25,
      nilaiRataRata: '89.60',
      nilaiAkhirSetelahBobot: '22.40'
    },
    {
      peran: 'Bawahan',
      bobot: '0%',
      bobotVal: 0.00,
      nilaiRataRata: '-',
      nilaiAkhirSetelahBobot: '0.00'
    }
  ],
  totalWeighting: {
    peran: 'Total / Nilai Akhir',
    bobot: '100%',
    nilaiRataRata: '-',
    nilaiAkhirSetelahBobot: '22.40',
    predikat: 'Sangat Kurang',
    predikatId: 'sangat-kurang'
  },
  berakhlakWeightings: [
    {
      coreValue: 'Berorientasi Pelayanan',
      deskripsi: 'Memahami & memenuhi kebutuhan layanan',
      rataRataAtasan: '-',
      rataRataSejawat: '100.00',
      hasilTerbobot: '25.00',
      predikat: 'Sangat Kurang',
      predikatId: 'sangat-kurang'
    },
    {
      coreValue: 'Akuntabel',
      deskripsi: 'Bertanggung jawab atas kepercayaan',
      rataRataAtasan: '-',
      rataRataSejawat: '73.33',
      hasilTerbobot: '18.33',
      predikat: 'Sangat Kurang',
      predikatId: 'sangat-kurang'
    },
    {
      coreValue: 'Kompeten',
      deskripsi: 'Terus belajar & tingkatkan kapabilitas',
      rataRataAtasan: '-',
      rataRataSejawat: '66.67',
      hasilTerbobot: '16.67',
      predikat: 'Sangat Kurang',
      predikatId: 'sangat-kurang'
    },
    {
      coreValue: 'Harmonis',
      deskripsi: 'Saling peduli & hargai perbedaan',
      rataRataAtasan: '-',
      rataRataSejawat: '80.00',
      hasilTerbobot: '20.00',
      predikat: 'Sangat Kurang',
      predikatId: 'sangat-kurang'
    },
    {
      coreValue: 'Loyal',
      deskripsi: 'Berdedikasi & utamakan bangsa',
      rataRataAtasan: '-',
      rataRataSejawat: '100.00',
      hasilTerbobot: '25.00',
      predikat: 'Sangat Kurang',
      predikatId: 'sangat-kurang'
    },
    {
      coreValue: 'Adaptif',
      deskripsi: 'Inovatif & antusias hadapi perubahan',
      rataRataAtasan: '-',
      rataRataSejawat: '100.00',
      hasilTerbobot: '25.00',
      predikat: 'Sangat Kurang',
      predikatId: 'sangat-kurang'
    },
    {
      coreValue: 'Kolaboratif',
      deskripsi: 'Membangun kerja sama sinergis',
      rataRataAtasan: '-',
      rataRataSejawat: '100.00',
      hasilTerbobot: '25.00',
      predikat: 'Sangat Kurang',
      predikatId: 'sangat-kurang'
    }
  ],
  berakhlakSummary: {
    rataRataAtasan: '-',
    rataRataSejawat: '89.09',
    keterangan: 'Setelah dikali bobot peran',
    nilaiFinal: '22.40',
    predikatFinal: 'Sangat Kurang',
    predikatFinalId: 'sangat-kurang'
  }
};
